import React, { useState, useCallback } from 'react'
import { Container, Grid, Box, Typography, Button, TextField } from '@mui/material'
import Table from './Table'
import { debounce } from 'lodash'
import { Link } from 'react-router-dom'

export const MapAdminScreen = () => {
  const [searchKey, setSearchKey] = useState('')

  const handleSearch = useCallback(
    debounce((value) => setSearchKey(value), 500),
    [],
  )

  return (
    <Container style={{ paddingTop: '2rem' }}>
      <Grid container spacing={2} alignItems='stretch'>
        <Grid item xs={12}>
          <Typography variant='h5'>MAP Panel</Typography>
        </Grid>
        <Grid item xs>
          <TextField
            label='Search'
            variant='outlined'
            onChange={(e) => handleSearch(e.target.value)}
            placeholder='Company Name'
            fullWidth
          />
        </Grid>
        <Grid item>
          <Button
            component={Link}
            to='/map/summary'
            variant='outlined'
            color='primary'
            sx={{ height: '100%' }}
          >
            MAP Summary
          </Button>
        </Grid>
        <Grid item>
          <Button
            component={Link}
            to='/map/create'
            variant='contained'
            color='primary'
            sx={{ height: '100%' }}
          >
            New MAP
          </Button>
        </Grid>
      </Grid>
      <Table searchKey={searchKey} />
    </Container>
  )
}
